import { Children, createContext, FC, isValidElement, ReactNode, useContext, useMemo } from 'react';
import { Option } from '../../../models/Option';
import { GridColumn, GridColumnProps } from './GridColumn';

interface FieldOption extends Option<string> {
    canBeHidden?: boolean;
}

const GridColumnFieldsContext = createContext<{ fields: FieldOption[] }>(undefined);

const GridColumnFieldsProvider: FC<{ gridChildren: ReactNode }> = ({ gridChildren, children }) => {
    const value = useMemo(
        () => ({
            fields: Children.toArray(gridChildren)
                .filter(isValidElement)
                .filter(e => e.type['displayName'] === GridColumn.displayName)
                .map(({ props: { field, title, canBeHidden } }: { props: GridColumnProps }) => ({ id: field, text: title, canBeHidden }))
        }),
        [gridChildren]
    );

    return <GridColumnFieldsContext.Provider value={value}>{children}</GridColumnFieldsContext.Provider>;
};
const useGridColumnFields = () => useContext(GridColumnFieldsContext);

export { GridColumnFieldsProvider, useGridColumnFields };
